import {
    getAuthorization,
    permissionsMapFromCapabilities
} from "../../utils/capabilityAccess";

const getUserSettings = (dashboard) => {
    const storage = JSON.parse(localStorage.getItem('usr') || '{}')
    if (dashboard) {
        return storage[dashboard] || {};
    }
    return storage;
}
const setUserSettings = (value) => {
    localStorage.setItem('usr', JSON.stringify(value));
}

export const clearUserSettings = () => {
    localStorage.removeItem('usr');
}

/**
 * F6c: in-page permission helpers read OrgRole capabilities (via authorization),
 * not legacy RolePermission maps from localStorage dual-write.
 */
export const UserSettings = {
    getSettings(id) {
        return id ? localStorage.getItem(id) : {};
    },
    setSetting(key, prop) {
        localStorage.setItem(key, prop)
    },
    getUserPermissions() {
        // Prefer capability-derived map; fall back to cached synthetic map only.
        const authz = getAuthorization();
        if (Array.isArray(authz.capabilities) && authz.capabilities.length > 0) {
            return {
                permissions: permissionsMapFromCapabilities(authz.capabilities),
                roleName: authz.orgRoleName || ''
            };
        }
        const perms = localStorage.getItem('userPermissions')
        const userPermissions = JSON.parse(perms === 'undefined' ? '{}' : perms || '{}');
        return userPermissions || {};
    },
    setUserPermissions(permissions) {
        localStorage.setItem('userPermissions', JSON.stringify(permissions));
    },
    getUserPermissionsByDashboardId(id){
        const {permissions = {}} = this.getUserPermissions() || {};
        if(String(permissions).equalsIgnoreCase?.('undefined')){
            return {};
        }
        return permissions[id] || {};
    },
    
    // Enhanced permission validation methods
    hasPermission(dashboardId, action) {
        const permissions = this.getUserPermissionsByDashboardId(dashboardId);
        return permissions[action] === true;
    },
    
    hasAnyPermission(dashboardId, actions) {
        const permissions = this.getUserPermissionsByDashboardId(dashboardId);
        return actions.some(action => permissions[action] === true);
    },
    
    hasAllPermissions(dashboardId, actions) {
        const permissions = this.getUserPermissionsByDashboardId(dashboardId);
        return actions.every(action => permissions[action] === true);
    },
    
    hasElevatedPrivileges(dashboardId) {
        return this.hasPermission(dashboardId, 'hasElevatedPrivileges');
    },
    
    // Permission validation with fallback
    validatePermission(dashboardId, action, fallback = false) {
        try {
            return this.hasPermission(dashboardId, action);
        } catch (error) {
            console.warn(`Permission validation error for ${dashboardId}.${action}:`, error);
            return fallback;
        }
    },
    
    // Get all user permissions for debugging
    getAllPermissions() {
        const {permissions = {}} = this.getUserPermissions() || {};
        return permissions;
    }
}
